/**
 * MIRA Avatar Component
 * Wraps Shadcn Avatar with MIRA design system styles
 */

import React from 'react';
import {
  Avatar as ShadcnAvatar,
  AvatarImage as ShadcnAvatarImage,
  AvatarFallback as ShadcnAvatarFallback,
} from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/data-display/avatar.module.css';

export const Avatar = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnAvatar
        ref={ref}
        className={cn(styles.miraAvatar, className)}
        {...props}
      />
    );
  }
);

Avatar.displayName = 'MiraAvatar';

export const AvatarImage = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnAvatarImage
        ref={ref}
        className={cn(styles.miraAvatarImage, className)}
        {...props}
      />
    );
  }
);

AvatarImage.displayName = 'MiraAvatarImage';

export const AvatarFallback = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnAvatarFallback
        ref={ref}
        className={cn(styles.miraAvatarFallback, className)}
        {...props}
      />
    );
  }
);

AvatarFallback.displayName = 'MiraAvatarFallback';
